// Generated file, do not modify, run `yarn import-locales` to refresh

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

// Turn of type checking, as we want to allow "any" types for the i18n keys.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const da_DK = {
  datePickerDialogMonthUnspecified: `(Uspecificeret)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Måned`,
  clearButton: `Ryd valg`,
  datePickerDialogYearListLabel: `Vælg år`,
  datePickerDialogMonthListLabel: `Vælg måned`,
  datePickerUnderflow: args => `Værdien skal være ${args.minValue} eller senere.`,
  datePickerOverflow: args => `Værdien skal være ${args.maxValue} eller tidligere.`,
  loading: `Loader...`,
  dateRangeFrom: args => `fra, ${args.label}`,
  dateRangeTo: args => `til, ${args.label}`,
  contentSelectInput: args => `${args.label}, søg, tryk tab for at vælge værdi`,
  contentSelectInputPlaceholder: `Søge`,
  confirmActionConfirm: `Bekræft`,
  confirmActionCancel: `Annuller`,
  confirmActionSelectedAnnouncement: `For at bekræfte valget skal du trykke på Tab for at gå til bekræftelsesknappen`
};
const de_DE = {
  datePickerDialogMonthUnspecified: `(Nicht spezifiziert)`,
  datePickerDialogTabYear: `Jahr`,
  datePickerDialogTabMonth: `Monat`,
  clearButton: `Auswahl löschen`,
  datePickerDialogYearListLabel: `Jahr auswählen`,
  datePickerDialogMonthListLabel: `Monat auswählen`,
  datePickerUnderflow: args => `Der Wert muss ${args.minValue} oder höher sein.`,
  datePickerOverflow: args => `Der Wert muss ${args.maxValue} oder früher sein.`,
  loading: `Geladen…`,
  dateRangeFrom: args => `von, ${args.label}`,
  dateRangeTo: args => `an, ${args.label}`,
  contentSelectInput: args => `${args.label}, suchen, Tab drücken um Wert auszuwählen`,
  contentSelectInputPlaceholder: `Suchen`,
  confirmActionConfirm: `Bestätigen`,
  confirmActionCancel: `Abbrechen`,
  confirmActionSelectedAnnouncement: `Um die Auswahl zu bestätigen, drücken Sie die Tabulatortaste, um zur Schaltfläche „Bestätigen“ zu gelangen`
};
const en_GB = {
  datePickerDialogMonthUnspecified: `(Unspecified)`,
  datePickerDialogTabYear: `Year`,
  datePickerDialogTabMonth: `Month`,
  clearButton: `Clear selection`,
  datePickerDialogYearListLabel: `Select year`,
  datePickerDialogMonthListLabel: `Select month`,
  datePickerUnderflow: args => `Value must be ${args.minValue} or later.`,
  datePickerOverflow: args => `Value must be ${args.maxValue} or earlier.`,
  loading: `Loading…`,
  dateRangeFrom: args => `from, ${args.label}`,
  dateRangeTo: args => `to, ${args.label}`,
  contentSelectInput: args => `${args.label}, search, tab to select value`,
  contentSelectInputPlaceholder: `Search`,
  confirmActionConfirm: `Confirm`,
  confirmActionCancel: `Cancel`,
  confirmActionSelectedAnnouncement: `to confirm the selection, press Tab to move to the confirm button`
};
const en_US = {
  datePickerDialogMonthUnspecified: `(Unspecified)`,
  datePickerDialogTabYear: `Year`,
  datePickerDialogTabMonth: `Month`,
  clearButton: `Clear selection`,
  datePickerDialogYearListLabel: `Select year`,
  datePickerDialogMonthListLabel: `Select month`,
  datePickerUnderflow: args => `Value must be ${args.minValue} or later.`,
  datePickerOverflow: args => `Value must be ${args.maxValue} or earlier.`,
  loading: `Loading…`,
  dateRangeFrom: args => `from, ${args.label}`,
  dateRangeTo: args => `to, ${args.label}`,
  contentSelectInput: args => `${args.label}, search, tab to select value`,
  contentSelectInputPlaceholder: `Search`,
  confirmActionConfirm: `Confirm`,
  confirmActionCancel: `Cancel`,
  confirmActionSelectedAnnouncement: `to confirm the selection, press Tab to move to the confirm button`
};
const fi_FI = {
  datePickerDialogMonthUnspecified: `(Määrittelemätön)`,
  datePickerDialogTabYear: `Vuosi`,
  datePickerDialogTabMonth: `Kuukausi`,
  clearButton: `Tyhjennä valinta`,
  datePickerDialogYearListLabel: `Valitse vuosi`,
  datePickerDialogMonthListLabel: `Valitse kuukausi`,
  datePickerUnderflow: args => `Arvon on oltava ${args.minValue} tai uudempi.`,
  datePickerOverflow: args => `Arvon on oltava ${args.maxValue} tai aikaisempi.`,
  loading: `Ladataan…`,
  dateRangeFrom: args => `alkaen, ${args.label}`,
  dateRangeTo: args => `kohteeseen, ${args.label}`,
  contentSelectInput: args => `${args.label}, hae, paina tab valitaksesi arvon`,
  contentSelectInputPlaceholder: `Haku`,
  confirmActionConfirm: `Vahvista`,
  confirmActionCancel: `Peruuta`,
  confirmActionSelectedAnnouncement: `Vahvista valinta siirtymällä vahvistuspainikkeeseen painamalla Tab-näppäintä`
};
const fr_FR = {
  datePickerDialogMonthUnspecified: `(Indéterminé)`,
  datePickerDialogTabYear: `Année`,
  datePickerDialogTabMonth: `Mois`,
  clearButton: `Effacer la sélection`,
  datePickerDialogYearListLabel: `Sélectionnez l'année`,
  datePickerDialogMonthListLabel: `Sélectionnez le mois`,
  datePickerUnderflow: args => `La valeur doit être ${args.minValue} ou ultérieure.`,
  datePickerOverflow: args => `La valeur doit être ${args.maxValue} ou antérieure.`,
  loading: `Chargement…`,
  dateRangeFrom: args => `de, ${args.label}`,
  dateRangeTo: args => `à, ${args.label}`,
  contentSelectInput: args => `${args.label}, rechercher, appuyez sur tab pour sélectionner une valeur`,
  contentSelectInputPlaceholder: `Recherche`,
  confirmActionConfirm: `Confirmer`,
  confirmActionCancel: `Annuler`,
  confirmActionSelectedAnnouncement: `pour confirmer la sélection, appuyez sur Tab pour passer au bouton de confirmation`
};
const no_NO = {
  datePickerDialogMonthUnspecified: `(Uspesifisert)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Måned`,
  clearButton: `Fjern valg`,
  datePickerDialogYearListLabel: `Velg år`,
  datePickerDialogMonthListLabel: `Velg måned`,
  datePickerUnderflow: args => `Verdien må være ${args.minValue} eller senere.`,
  datePickerOverflow: args => `Verdien må være ${args.maxValue} eller tidligere.`,
  loading: `Laster inn…`,
  dateRangeFrom: args => `fra, ${args.label}`,
  dateRangeTo: args => `til, ${args.label}`,
  contentSelectInput: args => `${args.label}, søk, trykk tab for å velge verdi`,
  contentSelectInputPlaceholder: `Søk`,
  confirmActionConfirm: `Bekreft`,
  confirmActionCancel: `Avbryt`,
  confirmActionSelectedAnnouncement: `For å bekrefte valget, trykk Tab for å gå til bekreftelsesknappen`
};
const sv_SE = {
  datePickerDialogMonthUnspecified: `(Ospecificerad)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Månad`,
  clearButton: `Rensa valet`,
  datePickerDialogYearListLabel: `Välj år`,
  datePickerDialogMonthListLabel: `Välj månad`,
  datePickerUnderflow: args => `Värdet måste vara ${args.minValue} eller senare.`,
  datePickerOverflow: args => `Värdet måste vara ${args.maxValue} eller tidigare.`,
  loading: `Laddar…`,
  dateRangeFrom: args => `från, ${args.label}`,
  dateRangeTo: args => `till, ${args.label}`,
  contentSelectInput: args => `${args.label}, sök, tryck tab för att välja värde`,
  contentSelectInputPlaceholder: `Sök`,
  confirmActionConfirm: `Bekräfta`,
  confirmActionCancel: `Avbryt`,
  confirmActionSelectedAnnouncement: `För att bekräfta valet, tryck på Tabbtangenten för att gå till bekräftelseknappen`
};
const locales = {
  "da-DK": da_DK,
  "de-DE": de_DE,
  "en-GB": en_GB,
  "en-US": en_US,
  "fi-FI": fi_FI,
  "fr-FR": fr_FR,
  "no-NO": no_NO,
  "sv-SE": sv_SE
};
export default locales;
//# sourceMappingURL=locales.js.map